import React from 'react';
import { cn } from '@express-labs/raven-tools';

import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const Call: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--call')}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g
      id="Call-Icon-32x32"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group" fillRule="nonzero">
        <g>
          <g
            id="Oringinal"
            transform="translate(5.243418, 4.989863)"
            stroke="#000000"
            strokeWidth="1.5"
          >
            <path
              d="M18.5246015,21.5393655 C15.2982494,22.4251725 11.1581475,20.7871302 6.06883857,15.6977338 C0.979478871,10.6082867 -0.658391321,6.46851022 0.229140108,3.23538586 C0.411169945,2.59464852 0.833983065,2.04909372 1.41631743,1.70875711 L4.41621577,-1.77635684e-14 L4.79645039,0.616362493 L6.49674393,3.37301322 L8.40862087,6.30216473 L7.87946347,6.72781233 L5.90421927,8.31638307 C5.71142718,8.46380428 5.6563893,8.73050498 5.77794508,8.94735039 L5.90703263,9.18191118 C6.60724769,10.4661531 7.21099967,11.2888333 8.8437705,12.9213683 C10.4766075,14.5539364 11.2992886,15.1577407 12.5858031,15.8594782 L12.8229272,15.9901631 C13.0345779,16.1088299 13.3012982,16.053792 13.4603782,15.8461389 L15.4688178,13.3524705 L21.7738551,17.5556135 L20.0475309,20.3663127 C19.7114096,20.9370049 19.1683173,21.3565315 18.5246015,21.5393655 Z"
              id="Path"
            />
          </g>
          <path
            d="M12.368217,7.95294026 L9.91771078,3.97972526 L6.28852776,6.04692607 C5.53302362,6.4884154 4.98644755,7.19190153 4.75110755,8.02028839 C3.73211003,11.7322092 5.72825817,16.1641711 10.7819222,21.217922 C15.8343452,26.2704318 20.26699,28.2682028 23.966587,27.2524646 C24.8009495,27.0155116 25.5026301,26.4746257 25.9371919,25.7367938 L28.0345468,22.3222501 L20.5580112,17.3381482 L18.238,20.218 L18.1912273,20.192491 C16.9704008,19.5265758 16.2175174,18.9589392 14.8761382,17.6376406 L14.3607186,17.1222998 C13.1276332,15.8708506 12.5510219,15.1318142 11.9405243,14.0500985 L11.779,13.76 L14.6512796,11.4507785 L12.368217,7.95294026 Z M9.401,5.999 L11.1018212,8.75660259 L12.6527987,11.1332762 L10.6776068,12.7218049 C10.2010135,13.0859553 10.0641686,13.7634684 10.3671413,14.3039465 L10.4933826,14.533383 C11.2698507,15.9574902 11.9535686,16.8385024 13.556897,18.4415993 C15.0662135,19.9506673 15.9353089,20.6449063 17.2233963,21.3710329 L17.7043396,21.6368756 L17.8216526,21.6947144 C18.3376933,21.9157897 18.9448142,21.7546592 19.2991684,21.2921071 L20.866,19.346 L26,22.768 L24.6518671,24.9636528 C24.4060685,25.3807347 24.0206987,25.6777945 23.5631032,25.8077649 C20.5021345,26.6481352 16.5539458,24.8687061 11.8425915,20.1572709 C7.1299827,15.4445812 5.35210455,11.4972347 6.19580262,8.4237877 C6.32333861,7.97497484 6.62371648,7.58836503 7.03817114,7.34614321 L9.401,5.999 Z"
            id="Path"
            fill="#000000"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Call;
